import * as React from 'react'
import {Box, Typography} from "@mui/material";


export default function numCompetitorsColumn() {
    return {
        name: 'numCompetitors', label: 'Num Seller Competitors',
        options: {
            setCellHeaderProps: () => ({ sx: {
                    whiteSpace: 'pre-wrap',
                }}),
            customBodyRowRenderLite: (value) => <Box sx={{ textAlign: 'center' }}>
                <Typography>{value}</Typography>
            </Box>
        }
    }
}